
import DividendService from "@/service/DividendService";
import FormatterService from "@/service/FormatterService";

    export default {
        name: 'ShareDividends',

        props: {
            share: Object
        },

        data () {
            return {
                dividends: [],
                isLoading: false,
            }
        },

        methods: {
            async queryDividends() {
                this.isLoading = true
                try {
                    this.dividends = await this.dividendService.getShareDividends(this.share.isin);
                } catch (e) {
                    console.error(e.message)
                    this.$gtag?.exception({description: e.message})
                } finally {
                    this.isLoading = false
                }
            },
        },

        async fetch() {
            await this.queryDividends()
        },

        created() {
            this.dividendService = new DividendService(this.$axios, this.$t)
            this.format = new FormatterService()
        },

        watch: {
            share() {
                this.$fetch()
            }
        },
    }
